var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GalleryBanner"},[_c('a',{staticClass:"Button Button--primary ViewGalleryButton",attrs:{"href":"/gallery"}},[_vm._v("\n    "+_vm._s(_vm.$t('galleryBanner.buttonTitle'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }